// remap jQuery to $
import "./vendor/plugins";
 
(function ($) {})(window.jQuery);
 
var ww, wh;
 
jQuery(document).ready(function ($) {
  format();
  init();
});
 
jQuery(window).resize(function () {
  format();
});
 
jQuery(window).load(function () {
  // pubsub.emit("windowLoad");
  //console.log($)
  console.log("%cCODE ahmedghazi.com", "color: blue; font-size:15px;");
});
 
function init() {
  //console.log("functions init")
  const btnToggle = document.querySelector(".button-menu-toggle")
  if(btnToggle){
    btnToggle.addEventListener("click", function() {
      const menuPrimary = document.querySelector("#menu-primary")
      if(menuPrimary){
        menuPrimary.classList.toggle("is-active")
        if (menuPrimary.classList.contains("is-active")) {
          btnToggle.innerText = 'fermer'
        } else {
          btnToggle.innerText = 'menu'
        }
      }
    })
  }
 
}
 
function format() {
  ww = jQuery(window).width();
  wh = jQuery(window).height();
}